/**
 * Menu bullets are authored as "<course>: <dish>" in every locale ("Starter: …",
 * "Plat : …", "مقبلات: …"), so the course label is data and needs no
 * translation key. Guarded so a bullet with a colon that isn't a course label
 * (a time like "19:00", a long sentence) degrades to an ungrouped dish rather
 * than inventing a heading.
 */
export function splitCourse(item: string): { course: string | null; dish: string } {
  const idx = item.indexOf(":");
  if (idx <= 0) return { course: null, dish: item };
  const course = item.slice(0, idx).trim();
  const dish = item.slice(idx + 1).trim();
  if (!dish || course.length > 24 || /\d/.test(course)) return { course: null, dish: item };
  return { course, dish };
}
